$(document).ready(function () {

    // Easing funkce (pro hladký efekt)
    const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

    // Hlavní funkce na animaci čítače
    function animateCounter($el, start, end, duration) {
        let startTimestamp = null;

        function step(timestamp) {
            if (!startTimestamp) startTimestamp = timestamp;
            const progress = Math.min((timestamp - startTimestamp) / duration, 1);
            const eased = easeOutCubic(progress);

            const current = Math.floor(start + (end - start) * eased);
            $el.text(current.toLocaleString("cs-CZ"));

            if (progress < 1) {
                requestAnimationFrame(step);
            }
        }

        requestAnimationFrame(step);
    }

    // IntersectionObserver – sleduje všechny prvky
    const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const $el = $(entry.target);

                const start = parseInt($el.data("counter-start")) || 0;
                const end = parseInt($el.data("counter-end")) || 0;
                const duration = parseInt($el.data("counter-duration")) || 2000;

                animateCounter($el, start, end, duration);

                obs.unobserve(entry.target); // spustí se jen jednou
            }
        });
    }, { threshold: 0.5 });

    // Připojit observer na všechny prvky s class="animated-counter"
    $(".animated-counter").each(function () {
        observer.observe(this);
    });

});
